// BUILDINGS
export const LOAD_BUILDINGS = "LOAD_BUILDINGS";
export const LOAD_BUILDINGS_SUCCESS = "LOAD_BUILDINGS_SUCCESS";
export const LOAD_BUILDINGS_FAILURE = "LOAD_BUILDINGS_FAILURE";
// VARIABLES
export const LOAD_VARIABLES = "LOAD_VARIABLES";
export const LOAD_VARIABLES_SUCCESS = "LOAD_VARIABLES_SUCCESS";
export const LOAD_VARIABLES_FAILURE = "LOAD_VARIABLES_FAILURE";

// VARIABLES EXPORT
export const LOAD_VARIABLES_EXPORT = "LOAD_VARIABLES_EXPORT";
export const LOAD_VARIABLES_EXPORT_SUCCESS = "LOAD_VARIABLES_EXPORT_SUCCESS";
export const LOAD_VARIABLES_EXPORT_FAILURE = "LOAD_VARIABLES_EXPORT_FAILURE";

// IMPORTS
export const LOAD_IMPORTS = "LOAD_IMPORTS";
export const LOAD_IMPORTS_SUCCESS = "LOAD_IMPORTS_SUCCESS";
export const LOAD_IMPORTS_FAILURE = "LOAD_IMPORTS_FAILURE";

export const EDIT_IMPORTS = "EDIT_IMPORTS";
export const EDIT_IMPORTS_SUCCESS = "EDIT_IMPORTS_SUCCESS";
export const EDIT_IMPORTS_FAILURE = "EDIT_IMPORTS_FAILURE";

export const DELETE_IMPORT = "DELETE_IMPORT";
export const DELETE_IMPORT_SUCCESS = "DELETE_IMPORT_SUCCESS";
export const DELETE_IMPORT_FAILURE = "DELETE_IMPORT_FAILURE";

// DOWNLOAD_CONFIGS
export const LOAD_DOWNLOAD_CONFIGS = "LOAD_DOWNLOAD_CONFIGS";
export const LOAD_DOWNLOAD_CONFIGS_SUCCESS = "LOAD_DOWNLOAD_CONFIGS_SUCCESS";
export const LOAD_DOWNLOAD_CONFIGS_FAILURE = "LOAD_DOWNLOAD_CONFIGS_FAILURE";
export const SEND_DOWNLOAD_CONFIGS = "SEND_DOWNLOAD_CONFIGS";
export const SEND_DOWNLOAD_CONFIGS_SUCCESS = "SEND_DOWNLOAD_CONFIGS_SUCCESS";
export const SEND_DOWNLOAD_CONFIGS_FAILURE = "SEND_DOWNLOAD_CONFIGS_FAILURE";
export const UPDATE_DOWNLOAD_CONFIGS = "UPDATE_DOWNLOAD_CONFIGS";
export const UPDATE_DOWNLOAD_CONFIGS_SUCCESS =
  "UPDATE_DOWNLOAD_CONFIGS_SUCCESS";
export const UPDATED_DOWNLOAD_CONFIGS_FAILURE =
  "UPDATED_DOWNLOAD_CONFIGS_FAILURE";
export const DELETE_DOWNLOAD_CONFIGS = "DELETE_DOWNLOAD_CONFIGS";
export const DELETE_DOWNLOAD_CONFIGS_SUCCESS =
  "DELETE_DOWNLOAD_CONFIGS_SUCCESS";
export const DELETE_DOWNLOAD_CONFIGS_FAILURE =
  "DELETE_DOWNLOAD_CONFIGS_FAILURE";

// DOWNLOAD_REQUEST
export const SEND_DOWNLOAD_REQUEST = "SEND_DOWNLOAD_REQUEST";
export const SEND_DOWNLOAD_REQUEST_SUCCESS = "SEND_DOWNLOAD_REQUEST_SUCCESS";
export const SEND_DOWNLOAD_REQUEST_FAILURE = "SEND_DOWNLOAD_REQUEST_FAILURE";

// FILES
export const LOAD_FILES = "LOAD_FILES";
export const LOAD_FILES_SUCCESS = "LOAD_FILES_SUCCESS";
export const LOAD_FILES_FAILURE = "LOAD_FILES_FAILURE";
export const DELETE_FILES = "DELETE_FILES";
export const DELETE_FILES_SUCCESS = "DELETE_FILES_SUCCESS";
export const DELETE_FILES_FAILURE = "DELETE_FILES_FAILURE";

//CLEAR_STORE
export const CLEAR_DOWNLOAD_CONFIG_SELF_DATE_STORE =
  "CLEAR_DOWNLOAD_CONFIG_SELF_DATE_STORE";
export const CLEAR_FILES_SELF_DATA_STORE = "CLEAR_FILES_SELF_DATA_STORE";

export const SAVE_IMPORT_FILE = "SAVE_IMPORT_FILE";
export const CLEAR_IMPORT_FILE = "CLEAR_IMPORT_FILE";

export const LOAD_HISTORY_VAR_CHANGE = "LOAD_HISTORY_VAR_CHANGE";
export const LOAD_LOAD_HISTORY_VAR_CHANGE_SUCCESS =
  "LOAD_LOAD_HISTORY_VAR_CHANGE_SUCCESS";
export const LOAD_LOAD_HISTORY_VAR_CHANGE_FAILURE =
  "LOAD_LOAD_HISTORY_VAR_CHANGE_FAILURE";
